import Api from './OrderCollectionApi';
import * as types from './OrderCollectionTypes';

export function viewSuccess(orderCollection) {
    return {
        type: types.GET_ORDER_COLLECTION_SUCCESS,
        result: orderCollection
    };
}

export function view(id: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.view(id).then((result: any) => {
            dispatch(viewSuccess(result));
        });
}

export function updateOrderCollectionName(id: number, name: string) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.updateOrderCollectionName(id, name);
}
